var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"containerDiv"},[_c('PCNavbar',{attrs:{"selectIndex":"gw3"}}),_c('MobileNavBar',{attrs:{"currentActive":2}}),_c('img',{staticClass:"bannerImgcss0",attrs:{"src":require("../assets/bannner/newsbg.png")}}),_c('News')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }